import { GET_DOCUMENT_BY_ID } from "../actions/types"

export default function _(state = null, action) {
    switch(action.type) {
        case GET_DOCUMENT_BY_ID:
            return action.payload
        default:
            return state
    }
}